import React, { useState } from 'react';
import contactHeroImage from '../assets/contact-one.jpg';

function ContactHero() {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="w-full h-[800px] relative" style={{ top: '80px' }}>
      <div
        className="absolute inset-0 bg-black bg-opacity-50 z-10"
        style={{ display: isLoaded ? 'none' : 'block' }}
      ></div>
      <img
        className="absolute inset-0 w-full h-[800px] object-cover"
        src={contactHeroImage}
        alt=""
        style={{ visibility: isLoaded ? 'visible' : 'hidden' }}
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
}


export default ContactHero;
